import { createContext, useCallback, useEffect, useRef } from "react";
import { ILayoutContext, ILayoutProps } from "./layout.interface";

const layoutInitValues: ILayoutContext = {
    navbar: { current: null },
    header: { current: null },
    main: { current: null },
    handleMenu: Function.prototype()
};

export const LayoutContext = createContext<ILayoutContext>(layoutInitValues);

const LayoutProvider = ({ children }: ILayoutProps) => {
    const navbar = useRef<HTMLElement>(null);
    const header = useRef<HTMLElement>(null);
    const main = useRef<HTMLElement>(null);

    const handleMenu = useCallback(
        (open?: boolean) => {
            if (open === undefined) navbar.current?.classList.toggle("is_active");
            else if (open) navbar.current?.classList.add("is_active");
            else navbar.current?.classList.remove("is_active");

            const isOpen = navbar.current?.classList.contains("is_active");
            if (isOpen) document.body.classList.add("overflow-hidden");
            else document.body.classList.remove("overflow-hidden");
        },
        [navbar]
    );

    return (
        <LayoutContext.Provider value={{ navbar, header, main, handleMenu }}>
            {children}
        </LayoutContext.Provider>
    );
};

export default LayoutProvider;
